import { connect } from 'react-redux';
import { formFinderDelete } from '../../../actions';
import FormFindersPanel from './FormFindersPanel';

const mapStateToProps = ({ formFinders }) => ({
    forms: formFinders.existing,
});

const mapDispatchToProps = (dispatch) => ({
    onDelete: (formFinder) => {
        dispatch(formFinderDelete(formFinder));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormFindersPanel);
